import React from "react";

import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Rounded } from "../../../theme/Rounded";
import { Spacing } from "../../../theme/Spacing";
import { Flex } from "../../../components/Flex";
import { Text } from "../../../components/Text";
import { Info } from "../../../components/Info";
import { formatReportPercent, getOriginLabel } from "../../../utils/Reports";
import { ReportCard } from "./ReportCard";

const OriginBar = styled.div`
  width: 100%;
  height: 0.85rem;
  min-height: 0.85rem;
  flex-shrink: 0;
  border-radius: ${Rounded.md};
  background-color: ${({ theme }) => theme.sub};
  overflow: hidden;
`;

const OriginFill = styled.div<{ share: number }>`
  width: ${({ share }) => Math.round(share * 100)}%;
  height: 100%;
  background-color: ${({ theme }) => theme.main};
  transition: width 0.2s ease;
`;

const OriginContainer = styled(ReportCard)``;

const OriginRow = styled(Flex)`
  flex-direction: column;
  gap: ${Spacing.xs};
`;

type Origin = {
  origin: string | null;
  count: number;
};

type Props = {
  origins: Origin[];
};

export const ReportOriginList: React.FC<Props> = ({ origins }) => {
  const total = origins.reduce((sum, { count }) => sum + count, 0);
  const { t } = useTranslation();

  if (!total) {
    return null;
  }

  return (
    <OriginContainer>
      <Info info={t("reports.origin.title")} />
      {origins.map(({ origin, count }) => {
        const share = count / total;

        return (
          <OriginRow key={origin || "unknown"}>
            <Flex alignItems="baseline" justifyContent="space-between">
              <Text>{getOriginLabel(origin, t)}</Text>

              <Flex alignItems="baseline" gap="xs">
                <Text fontWeight="bold">{count}</Text>
                <Text fontSize="s" color="darkerSub">
                  {formatReportPercent(share)}%
                </Text>
              </Flex>
            </Flex>

            <OriginBar>
              <OriginFill share={share} />
            </OriginBar>
          </OriginRow>
        );
      })}
    </OriginContainer>
  );
};
